var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-banner-slider"},[_c('a-slider',{staticClass:"event-slider",attrs:{"theme":_vm.theme,"pagination-alignment":"center","options":_vm.sliderOptions}},_vm._l((_vm.banners),function(banner,i){return _c('a-slide',{key:i,staticClass:"event-slide"},[_c('event-banner',_vm._b({},'event-banner',banner,false))],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }